import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  Textarea,
  Button,
  useColorModeValue,
  useToast,
  Flex,
  Tooltip
} from "@chakra-ui/react";
import { cqAPI } from "../../lib/Auth";
import { EditIcon } from "@chakra-ui/icons";


const CustomizeAI = () => {
  const bgColor = useColorModeValue("gray.100", "gray.700");
  const [instructions, setInstructions] = useState('');
  const [vavGreeting, setVavGreeting] = useState('');
  const [defaultGreeting, setDefaultGreeting] = useState('');
  const [isInstructionEditing, setIsInstructionEditing] = useState(false);
  const [isGreetingEditing, setIsGreetingEditing] = useState(false);
  const [isVavEnable, setIsVavEnable] = useState(false);
  const [defaultGreetingStart, setDefaultGreetingStart] = useState('');
  const toast = useToast();


  useEffect(() => {
    const fetchAiSettings = async () => {
      try {
        const response = await cqAPI.get("/settings/ai");
        if (response.type === "ok") {
          setInstructions(response?.data?.instructions || "");
          setDefaultGreetingStart(response?.data?.vav?.start || '');
          setDefaultGreeting(response?.data?.vav?.default_value || '');
          if (response.data?.vav?.greeting){
            setVavGreeting(response.data?.vav?.start + response?.data?.vav?.greeting);
          } else {
            setVavGreeting(response?.data?.vav?.default_value || '')
          }
          setIsVavEnable(response.data.vav.enabled);
        }
        console.log(vavGreeting)
      } catch (error) {
        console.error("Error loading voice auto pilot greeting:", error);
        toast({
          title: "Error",
          description: "Failed to load voice auto pilot greeting.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };
    fetchAiSettings();
  }, []);

  const handleSaveInstructions = async () => {
    try {
      const response = await cqAPI.post("/settings/ai", {
        instructions: instructions,
      });
      if (response.type === "ok") {
        toast({
          title: "Saved successfully.",
          description: response.msg || "Your instructions have been saved.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setIsInstructionEditing(false);
      } else {
        toast({
          title: "Error",
          description: response.msg || 'Failed to save!',
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.msg,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleSaveGreeting = async () => {
    try {
      if (!vavGreeting.startsWith(defaultGreetingStart)) {
        toast({
          title: "Error",
          description: `Your greetings should start with: "${defaultGreetingStart}". reset to default if needed.`,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
        return
      }

      const response = await cqAPI.post("/settings/ai", {
        greeting: vavGreeting,
      });

      if (response.type === "ok") {
        toast({
          title: response.msg || "Saved successfully.",
          description: "Your voice auto pilot greeting have been saved.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setIsGreetingEditing(false);
      } else {
        toast({
          title: "Error",
          description: response.msg || 'Failed to save!',
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.msg,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  const handleGreetingChange = async (value) => {
    const toastId = "default-toast";

    if (!value.startsWith(defaultGreetingStart)) {
      if (!toast.isActive(toastId)){
        return toast({
          id:toastId,
          title: "Error",
          description: `You cannot remove ${defaultGreetingStart}.`,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
      return;
    }
    setVavGreeting(value)
  }


  return (
    <Box p={4} overflowY="auto" maxH="100vh" w="100%" align="left">
      <Box p={4} bgColor={bgColor} borderRadius="md">
        <Flex align="center" minH="200px" flexDirection="column" alignItems="start">
          <Flex flexDirection="row" alignItems="center" width="100%">
            <Flex justifyContent="flex-start">
              <Text fontSize="sm" fontWeight="bold" mb={2} ml={2}>
                What would you like <strong>Response Suggestion</strong> to know about your practice to provide better
                responses?
              </Text>
            </Flex>
            <Flex justifyContent="flex-end" ml='auto' gap={2} mb={2} minHeight="40px" alignItems="center">
              {isInstructionEditing ? (
                  <>
                    <Button id={"cancel-instructions"} size="sm" onClick={() => setIsInstructionEditing(false)}>cancel</Button>
                    <Button id={"save-instructions"} size="sm" onClick={handleSaveInstructions}>save</Button>
                  </>)
                :
                (<EditIcon id={"edit-instructions"} mr={1} onClick={() => setIsInstructionEditing(true)}/>)}
            </Flex>
          </Flex>
          <Tooltip
            label="Select edit to make changes"
            aria-label="A tooltip"
            isDisabled={isGreetingEditing}
            placement="top-end"
            mr={6}
          >
            <Textarea
              isDisabled={!isInstructionEditing}
              placeholder="Enter your instructions here..."
              id="ai_instructions"
              minH="120px"
              value={instructions}
              onChange={(e) => setInstructions(e.target.value)}
            />
          </Tooltip>

        </Flex>
        <Flex align="center" minH="200px" flexDirection="column" alignItems="start">
          <Flex flexDirection="row" alignItems="center" width="100%">
            <Flex justifyContent="flex-start">
              <Text fontSize="sm" fontWeight="bold" mb={2} ml={2}>
                Voice Auto Pilot Greeting:
              </Text>
            </Flex>
            <Flex justifyContent="flex-end" ml='auto' gap={2} mb={2} minHeight="40px" alignItems="center">
              { isVavEnable && isGreetingEditing ? (
                  <>
                    <Button id={"reset-greeting"} onClick={() => setVavGreeting(defaultGreeting)}
                            size="sm" variant="ghost" mr={3} mt={1}>Reset to Default</Button>
                    <Button size="sm" id={"cancel-greeting"} onClick={() => setIsGreetingEditing(false)}>cancel</Button>
                    <Button size="sm" id={"save-greeting"} onClick={handleSaveGreeting}>save</Button>
                  </>)
                :
                 isVavEnable && (<EditIcon id={"edit-greeting"} mr={1} onClick={() => isVavEnable && setIsGreetingEditing(true)}/>)
              }
            </Flex>
          </Flex>

          <Tooltip
            label= {isVavEnable ? "Select edit to make changes" : "You need to enable autopilot feature." }
            aria-label="A tooltip"
            isDisabled={isGreetingEditing}
            placement="top-end"
            mr={6}
          >
            <Textarea
              isDisabled={!isGreetingEditing}
              placeholder="Enter your voice auto pilot greeting here..."
              id="vav_greeting"
              minH="120px"
              value={vavGreeting}
              onChange={(e) => handleGreetingChange(e.target.value)}
            />
          </Tooltip>
        </Flex>
      </Box>
    </Box>
  );
};

export default CustomizeAI;
